"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalWrapper = void 0;
const ConditionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? wrapper?.(children) : children;
};
exports.ConditionalWrapper = ConditionalWrapper;